import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Papa from 'papaparse';
import moment from 'moment';
import Const from '../../util/Constants';
import CallAPI from '../../api/CallAPI';
import Util from '../../util/Util';
import FilterPannel from '../filter/FilterPannel';

class FixedCallReport extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model);
    this.call = this.model.call;
    this.users = this.model.user.options;
    this.progress = this.model.lead.fields.progress.options;
    this.project = this.model.project.options;
    this.source = this.model.source.options;
    this.direction = this.call.fields.direction.options;
    this.feedback = this.call.fields.feedback.options;
    this.complete = [{id:1 , name:'Yes'},{id:2 , name:'No'}];
    this.filters = [];
    this.state = { 
      inApiCall: false, 
      isFilterOpen: true, 
    };
  }

  handleCsv = async () => {
      this.setState({ inApiCall: true });
      await CallAPI.getFixedCallReportList(this.filters, this.onReceived, this.onFail);
  };

  onReceived = (response) => {
    try {
      if (response && Array.isArray(response)) {
        response.map((obj) =>{
            Object.keys(obj).forEach(key => {
              if(typeof obj[key] === 'string' && obj[key].indexOf(Const.Opt) !== -1){
                obj[key] = obj[key].split(Const.Opt).join("")
              }
                if (obj[key] === null || obj[key] === '~~' || obj[key] === '') {
                  obj[key] = '-';
                }
            });            
            obj.progress = this.progress.find((pro)=>pro.value === obj?.progress)?.label;
            obj.project = this.project.find((pro)=>pro.value === parseInt(obj?.project))?.label;
            obj.source = this.source.find((pro)=>pro.value === obj?.source)?.label;
            obj.direction = this.direction.find((pro)=>pro.value === obj?.direction)?.label;
            obj.feedback = this.feedback.find((pro)=>pro.value === obj?.feedback)?.label;
            obj.complete = this.complete.find((pro)=>pro.id === obj?.complete)?.name;
            obj.responsible_person = this.users.find((pro)=>pro.value === obj.responsible_person)?.name;
            obj.end_call = moment(obj.end_call).local().format('DD-MM-YYYY HH:mm:ss');
            obj.date_time = moment(obj.date_time).local().format('DD-MM-YYYY HH:mm:ss');
            obj.enquiry_date = moment(obj.enquiry_date).local().format('DD-MM-YYYY HH:mm:ss');
            obj.created_date = moment(obj.created_date).local().format('DD-MM-YYYY HH:mm:ss');
            obj.updated_date = moment(obj.updated_date).local().format('DD-MM-YYYY HH:mm:ss');
            obj.created_by = this.users.find((pro)=>pro.value === obj.created_by)?.name;
            obj.updated_by = this.users.find((pro)=>pro.value === obj.updated_by)?.name;
          return obj;
          })
        this.generateCSV(response);
      } else {
        throw new Error("Invalid data format from API");
      }
    } catch (error) {
      this.onFail(error);
    }
  };

  generateCSV = (data) => {
    try {
      const csv = Papa.unparse(data, { header: true });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'CallReport.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Util.showNotification('Successful', 'Call Report Downloaded successfully', 'success');

    } catch (error) {
      console.error("Error generating CSV:", error);
      Util.showError("Failed to generate CSV file");
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  onFail = (error) => {
    this.setState({ inApiCall: false });
    console.error("API call failed:", error);
    Util.showError("Something Went Wrong");
  };

  toggleFilter = () => {
    this.setState((prevState) => ({ isFilterOpen: !prevState.isFilterOpen }));
  };

  closeFilter = () => {
    this.setState({ isFilterOpen: false });
  };

  onFilterChange = (filters) => {
    this.filters = filters; 
    if(filters.length === 0) return
    Util.showNotification('Successful', 'Filter Applied successfully', 'success');
  };

  render() {
    if (!this.call || !this.call.fields) return null;

    return (
      <div style={{ padding: '20px', backgroundColor: '#f9f9f9', textAlign: 'center' }}>
        {/* Heading and Buttons in One Line */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
          <h1 style={{ margin: '0', color: '#333' }}>Call Report</h1>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
          {/* Filter Button */}
          {/* <button 
            onClick={this.toggleFilter} 
            disabled={this.state.inApiCall}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 20px',
              border: '1px solid #007bff',
              backgroundColor: '#ffffff',
              color: '#007bff',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            <FaFilter style={{ marginRight: '8px' }} />
            {this.state.isFilterOpen ? 'Close Filter' : 'Filter'}
          </button> */}

          {/* Download CSV Button */}
          <button 
            onClick={this.handleCsv} 
            disabled={!this.filters}
            style={{
              padding: '10px 20px',
              backgroundColor: this.state.inApiCall ? '#cccccc' : '#28a745',
              color: '#ffffff',
              border: 'none',
              borderRadius: '5px',
              cursor: this.state.inApiCall ? 'not-allowed' : 'pointer',
              fontSize: '14px',
            }}
          >
            {this.state.inApiCall ? 'Preparing CSV...' : 'Download Report'}
          </button>
        </div>
        </div>

        {/* Filter Panel */}
        {this.state.isFilterOpen && (
          <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }}>
            <FilterPannel
              filters={this.filters}
              fields={this.call.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FixedCallReport;
